import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-project-tab-placeholder',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="empty-tab-state">
      <mat-icon class="empty-icon" aria-hidden="true">folder_open</mat-icon>
      <p>Contenu de l'onglet "{{ label }}" en cours de développement</p>
    </div>
  `,
  styles: [`
    .empty-tab-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 300px;
      color: #64748b;
    }
    .empty-icon {
      font-size: 3rem;
      margin-bottom: 1rem;
      color: #98a2b3;
    }
  `]
})
export class ProjectTabPlaceholderComponent {
  @Input() label: string = '';
}
